export enum GenderEnum {
  Man = 'man',
  Woman = 'woman',
}
